export const componentBackgroundColor = "#faf9f7"
export const componentBorderColor = "#eaeaea"

export const textColor = "#1a1a1a"
export const lightTextColor = "#6b6a69"

export const successColor = "#007a3d"
export const dangerColor = "#d92d20"

export const pageContentWidth = 1200

export const cardColor = {
	blue: "#E5F6FF",
	orange: "#FFF0DD",
	purple: "#F9F5FF",
	gray: "#F4F4F4",
}

export const fonts = {
	mono: "Roboto Mono, monospace",
}
